import { create } from 'zustand'

// Claves de caché local de preferencias del chart (ver hooks/useIndicatorState.js,
// hooks/useChartLayout.js, pages/ChartPage.jsx) — deben borrarse al cerrar sesión
// para que el siguiente usuario que entre en este mismo navegador no herede ni
// vea por un instante la configuración de la cuenta anterior. El servidor sigue
// siendo la fuente de verdad (GET /auth/chart-preferences al montar), esto sólo
// evita el flash del caché local de la cuenta saliente.
const CHART_CACHE_KEYS = ['chart_indicator_state_v2', 'chart_layout_state', 'chart_favorites']

const useAuthStore = create((set) => ({
  user:  null,
  token: localStorage.getItem('access_token'),

  setUser:  (user)  => set({ user }),
  setToken: (token) => {
    localStorage.setItem('access_token', token)
    set({ token })
  },
  setTokens: (access, refresh) => {
    localStorage.setItem('access_token', access)
    localStorage.setItem('refresh_token', refresh)
    set({ token: access })
  },
  logout: () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    for (const key of CHART_CACHE_KEYS) localStorage.removeItem(key)
    set({ user: null, token: null })
  },
  isAuthenticated: () => !!localStorage.getItem('access_token'),
}))

export default useAuthStore
